import { apiClient } from '@/services/ApiClient.js'

export default {
  search(query) {
    return apiClient
      .get('search', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
